/********************************
 **** Media Gallery: Video autoplay
 *********************************/
// On variant switch, video autoplay

const MediaGalleryAutoplay = (() => {
  const initMediaGalleryAutoplay = () => {
    document.querySelectorAll(".page-product media-gallery[data-section-id]").forEach(gallery => {
      const sectionId = gallery.dataset.sectionId
      const observer = new MutationObserver(() => {
        const video = document.querySelector(
          `.page-product #MediaGallery-${sectionId} .video-item video`
        )
        if (video) {
          video.currentTime = 0
          video.play().catch(() => {})
        }
      })

      const targetGallery = document.getElementById(`MediaGallery-${sectionId}`)
      if (targetGallery) {
        observer.observe(targetGallery, { childList: true, subtree: true })
      }
    })
  }

  // Explicit play/pause — autoplay won't re-trigger after pauseAllMedia()
  const initHoverVideoListeners = () => {
    document.querySelectorAll(".video.hover").forEach(video => {
      const card = video.closest(".card-wrapper")
      if (!card || card.dataset.videoHoverBound) return
      card.dataset.videoHoverBound = "true"
      card.addEventListener("mouseenter", () => video.play().catch(() => {}))
      card.addEventListener("mouseleave", () => {
        video.pause()
        video.currentTime = 0
      })
    })
  }

  // Resume PDP video after modal closes
  const resumeAfterModal = () => {
    const pdpVideo = document.querySelector("#product-variant-video")
    if (pdpVideo) pdpVideo.play().catch(() => {})
  }

  return { initMediaGalleryAutoplay, initHoverVideoListeners, resumeAfterModal }
})()

document.addEventListener("DOMContentLoaded", () => {
  MediaGalleryAutoplay.initMediaGalleryAutoplay()
  MediaGalleryAutoplay.initHoverVideoListeners()
})

// Defer to next tick — modalClosed fires before pauseAllMedia() in ModalDialog.hide
document.body.addEventListener("modalClosed", () => {
  setTimeout(() => MediaGalleryAutoplay.resumeAfterModal(), 0)
  MediaGalleryAutoplay.initHoverVideoListeners()
})